import React, { useEffect, useState } from "react";
import DatePicker from "../../../form/DatePicker";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import {
  addEditScholarship,
  scholarshipList,
} from "../../../../services/scholarshipService";
import useMutation from "../../../../hooks/useMutation";
import { useDebounce } from "../../../../hooks/useDebounce";
import useFetch from "../../../../hooks/useFetch";
import { removeDuplicateFromArray } from "../../../../helpers";

const validation = {
  title: { required: true, message: "Title is required" },
};

const ManageScholarshipTimeline = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const [scholarshipFilters, setScholarshipFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [scholarshipkeyword, setScholarshipkeyword] = useState("");
  const scholarshipsSearch = useDebounce(scholarshipkeyword, 300);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  const {
    data: scholarshipTimeline,
    error: scholarshipTimelineError,
    isLoading: scholarshipTimelineLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: [
      "scholarshipTimelineData",
      scholarshipFilters,
      scholarshipsSearch,
    ],
    fetchFunction: async () => {
      const res = await scholarshipList({
        ...scholarshipFilters,
        ...(scholarshipsSearch && { keyword: scholarshipsSearch }),
      });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: removeDuplicateFromArray([
            ...(scholarshipTimeline?.data || []),
            ...res?.docs?.data,
          ]),
        };
      } else {
        if (scholarshipTimeline?.data?.length > 0) {
          return scholarshipTimeline;
        } else {
          return res;
        }
      }
    },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
      });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await addEditScholarship({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  function loadData(e, obj, setData = () => {}) {
    if (
      Math.ceil(e.target.scrollTop) + 20 >=
        e.target.scrollHeight - e.target.clientHeight &&
      obj?.metadata?.hasNextPage
    ) {
      setData((pre) => ({
        ...pre,
        page: obj?.metadata?.nextPage,
      }));
    }
  }

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        {/* <div className="relative col-span-4">
          <Input
            label={"Application Title"}
            inputPlaceholder={"Enter Application Title"}
            inputName="title"
            value={values?.title || ""}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div> */}
        <div className="relative col-span-12">
          <Select
            label={"Application Title"}
            placeholder={"Enter Application Title"}
            selectedValue={values?.title || ""}
            dropdownData={[
              // {
              //   name: data?.title,
              //   value: data?._id,
              // },
              ...(scholarshipTimeline?.data || [])?.map((scholarship) => ({
                name: scholarship?.title,
                value: scholarship?.title,
              })),
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "title", value: val },
              });
            }}
            onScroll={(e) => {
              loadData(e, scholarshipTimeline, setScholarshipFilters);
            }}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <DatePicker
            type="input"
            label={"Open Date"}
            value={{
              startDate: values?.publishDate,
              endDate: values?.publishDate,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "publishDate" },
              });
            }}
            {...formValidate(errors, "publishDate")}
          />
        </div>
        <div className="relative col-span-4">
          <DatePicker
            type="input"
            label={"Close Date"}
            value={{
              startDate: values?.publishEndDate,
              endDate: values?.publishEndDate,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "publishEndDate" },
              });
            }}
            {...formValidate(errors, "publishEndDate")}
          />
        </div>
        {/* <div className="relative col-span-2 space-y-4">
                    <div className={"text-xs font-medium text-shades-07 font-CanelaDeck "}>Choose Recurring</div>
                    <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center gap-2">
                            <Checkbox
                                checkboxLabel={"Recurring Open?"}
                                checkboxLableClass={"!text-sm"}
                                checkboxName={"recurringOpen"}
                                checked={values?.recurringOpen === "yes" ? true : false}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: e.target.name,
                                            value: e.target.checked ? "yes" : "no",
                                        },
                                    });

                                }}
                            />
                            <Tooltip position={'top'} messageClass="max-w-52" message={"scholarship will automatically be available to the users on the front-end on the set open date each year"}>
                                <i className="fa-fw fa-regular fa-info-circle text-chestnut-rose text-xs"></i>
                            </Tooltip>
                        </div>
                        <div className="flex items-center gap-2">
                            <Checkbox
                                checkboxLabel={"Recurring Close?"}
                                checkboxLableClass={"!text-sm"}
                                checkboxName={"recurringClose"}
                                checked={values?.recurringClose === "yes" ? true : false}
                                onChange={(e) => {
                                    handleChange({
                                        target: {
                                            name: e.target.name,
                                            value: e.target.checked ? "yes" : "no",
                                        },
                                    });

                                }}
                            />
                            <Tooltip position={'top'} messageClass="max-w-52" message={"scholarship will automatically be unavailable to the users on the front-end on the set closed date each year"}>
                                <i className="fa-fw fa-regular fa-info-circle text-chestnut-rose text-xs"></i>
                            </Tooltip>
                        </div>
                    </div>
                    <div className="relative">
            <Input
              label={"Recurring Open?"}
              inputPlaceholder={"Enter Yes/No"}
              inputName="recurringOpen"
              value={values?.recurringOpen}
              onChange={handleChange}
              {...formValidate(errors, "recurringOpen")}
            />
          </div>
          <div className="relative">
            <Input
              label="Recurring Close?"
              inputPlaceholder={"Enter Yes/No"}
              inputName="recurringClose"
              value={values?.recurringClose}
              onChange={handleChange}
              {...formValidate(errors, "recurringClose")}
            />
          </div>
                </div>
                <div className="relative col-span-2">
                    <Select
                        label={"Assign Eligibility Quiz"}
                        placeholder="Select Eligibility Quiz"
                        selectedValue={values?.quizeId}
                        dropdownData={removeDuplicateFromArray(
                            [
                                {
                                    name: data?.quizeDetails?.title,
                                    value: data?.quizeDetails?._id,
                                },
                                ...(quizs?.data || [])?.map((item) => ({
                                    value: item?._id,
                                    name: item?.title,
                                })),
                            ],
                            "value"
                        )}
                        setSelectedValue={(val) => {
                            handleChange({
                                target: { name: "quizeId", value: val },
                            });
                        }}
                        onScroll={(e) => loadData(e, quizs, setQuizsFilters)}
                    />
                </div>
                <div className="relative col-span-4">
                    <Editor
                        label="Requirements"
                        placeholder="At Vpeters family scholarship, we believe in the "
                        value={values?.requirement}
                        onChange={(val) => handleChange({ target: { name: "requirement", value: val } })}
                        {...formValidate(errors, "requirement")}
                    />
                </div>
                <div className="relative col-span-4">
                    <Editor
                        label="Application Instructions"
                        placeholder="At Vpeters family scholarship, we believe in the "
                        value={values?.applicationInstruction}
                        onChange={(val) =>
                            handleChange({
                                target: { name: "applicationInstruction", value: val },
                            })
                        }
                        {...formValidate(errors, "applicationInstruction")}
                    />
                </div>
                <div className="relative">
                    <Input
                        label={"Max Number of Recipients"}
                        inputPlaceholder={"Enter Recipients Number"}
                        inputName="maxNumberOfRecipient"
                        value={values?.maxNumberOfRecipient}
                        onChange={handleChange}
                        {...formValidate(errors, "maxNumberOfRecipient")}
                    />
                </div>
                <div className="relative">
                    <Input
                        label={"Scholarship Amount"}
                        inputPlaceholder={"Enter Amount"}
                        inputName="scholarshipAmount"
                        value={values?.scholarshipAmount}
                        onChange={handleChange}
                        {...formValidate(errors, "scholarshipAmount")}
                    />
                </div>
                <div className="relative">
                    <Select label={"Application Form"} placeholder="Application Form" />
                </div> */}

        <div className="relative col-span-4">
          <Select
            label={"Status"}
            placeholder="Select status"
            selectedValue={values?.status}
            dropdownData={[
              { name: "Published", value: 1 },
              { name: "Draft", value: 2 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "status", value: val },
              });
            }}
          />
        </div>

        {/* <div className="relative col-span-4">
                    <Textarea label={"Admin Notes"} inputPlaceholder={"special instructions"} inputName={"notes"} value={values?.notes} onChange={handleChange} />
                </div> */}
      </div>

      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Submit"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageScholarshipTimeline;
